import React, { useEffect } from "react";
import ProjectImg from '../Images/Project.jpg';
import project1 from '../Images/project1.jpg';
import UrlTag from "../components/UrlTag";
import { Link } from "react-router-dom";
import { FaArrowRight } from "react-icons/fa";

const items = [
    {
        title: "Coming Soon...",
        imgSrc: project1,
        imgAlt: "Project 1",
        linkSrc: "project-1"
    },
    // {
    //     title: "Project 2",
    //     imgSrc: studio1,
    //     imgAlt: "Project 2",
    //     linkSrc: "project-2"
    // },
    // {
    //     title: "Project 3",
    //     imgSrc: studio1,
    //     imgAlt: "Project 3",
    //     linkSrc: "project-3"
    // },
    // {
    //     title: "Project 4",
    //     imgSrc: studio1,
    //     imgAlt: "Project 4",
    //     linkSrc: "project-4"
    // }
];

const Projects = () => {
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <div>
            <UrlTag />
            <div className="relative">
                <img src={ProjectImg} alt="Projects" className="w-full h-[300px] md:h-[500px] object-cover" />
                <div className="absolute inset-0 bg-black opacity-40"></div>
                <div className="absolute bottom-0 left-0 py-4 sm:py-6 md:py-8 px-4 sm:px-6 md:px-8 lg:px-14">
                    <h1 className="text-white text-3xl sm:text-4xl font-bold">Projects</h1>
                </div>
            </div>
            <div className="mt-16 w-full px-4 sm:px-8 md:px-16 mx-auto mb-10">
                <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                    {items.map((item, index) => (
                        <div key={index}>
                            {/* <Link to={`/projects/${item.linkSrc}`} key={index} > */}
                            <div className="bg-[#f5f5f5] rounded-lg overflow-hidden hover:shadow-md transition-shadow duration-300">
                                <img src={item.imgSrc} alt={item.imgAlt} className="w-full h-56 object-cover transition-transform duration-500 ease-in-out hover:scale-105" />
                                <div className="px-6 py-4 flex justify-between items-center">
                                    <h2 className="text-lg md:text-2xl text-gray-700 font-semibold">{item.title}</h2>
                                    <button className="text-gray-500 p-2 bg-white rounded-full">
                                        <FaArrowRight />
                                    </button>
                                </div>
                            </div>
                            {/* </Link> */}
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default Projects;